/**
 * Suggested prompts configuration for RiseAI Chat cards in welcome screen
 */

import NRVulnVoltIcon from '../../NRIcons/NRVulnVoltIcon';
import NRMisconfigurationIcon from '../../NRIcons/NRMisconfigurationIcon';
import NRSBOMIcon from '../../NRIcons/NRSBOMIcon';
import NRReachableComponentIcon from '../../NRIcons/NRReachableComponentIcon';

export const SUGGESTED_PROMPTS = [
  {
    title: 'Top Vulnerabilities',
    text: 'What are my top vulnerabilities that I need to handle first?',
    icon: NRVulnVoltIcon
  },
  {
    title: 'Failed Misconfigurations',
    text: 'What is the potential outcome of the misconfigurations on this asset?',
    icon: NRMisconfigurationIcon
  },
  {
    title: 'Components out-of-date',
    text: "What are the easiest components to update that don't have downstream effects?",
    icon: NRSBOMIcon
  },
  {
    title: 'Reachable Vulnerabilities',
    text: 'What is the risk involved with my reachable vulnerabilities?',
    icon: NRReachableComponentIcon
  }
];
